import { render, staticRenderFns } from "./setList.vue?vue&type=template&id=ba2a1c18&"
import script from "./setList.vue?vue&type=script&lang=js&"
export * from "./setList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "setList.vue"
export default component.exports